/**
 * @ngdoc directives
 * @memberof mercury.modules.cashup
 * @name cashupcashinput
 * @description Input directive to allow setting a money total using individual current amounts
 */
angular.module('mercury.modules.cashup.edit')
.directive('cashupcashinput', ["$compile", "$parse", "$templateCache", "$timeout", function($compile, $parse, $templateCache, $timeout) {
  return {
    restrict: 'A',
    scope: true,
    require: 'ngModel',
    link: function(scope, elem, attrs, ngModelCtrl) {
      scope.popoverOpen = false;
      scope.workingCash = 0;

      scope.totalCash = $parse(attrs.ngModel)(scope);

      scope.cashTypes = [
        {label: '$100', ratio: 100, quantity: 0},
        {label: '$50', ratio: 50, quantity: 0},
        {label: '$20', ratio: 20, quantity: 0},
        {label: '$10', ratio: 10, quantity: 0},
        {label: '$5', ratio: 5, quantity: 0},
        {label: 'Other', ratio: 1, quantity: 0},
        {label: '$2', ratio: 2, quantity: 0},
        {label: '$1', ratio: 1, quantity: 0},
        {label: '50c', ratio: 0.5, quantity: 0},
        {label: '20c', ratio: 0.2, quantity: 0},
        {label: '10c', ratio: 0.1, quantity: 0}
      ];

      scope.updateTotal = function() {
        scope.workingCash = 0;
        angular.forEach(scope.cashTypes, function(type) {
          scope.workingCash += (type.quantity * type.ratio);
        });
      };

      scope.apply = function() {
        scope.totalCash = angular.copy(scope.workingCash);

        $parse(attrs.ngModel).assign(scope, scope.totalCash);

        scope.$eval(attrs.ngChange);

        scope.popoverOpen = false;
      };

      scope.totalUpdated = function() {
        $parse(attrs.ngModel).assign(scope, scope.totalCash);

        scope.$eval(attrs.ngChange);
      };

      elem.on('blur', function() {
        $timeout(function() {
          ngModelCtrl.$viewValue = formatter(ngModelCtrl.$modelValue);
          ngModelCtrl.$render();
        });
      });

      var template = $compile($templateCache.get('modules/cashup/edit/cashupcashinput.tpl.html'))(scope);
      elem.after(template);

      scope.$watch(attrs.ngModel, function(value) {
        scope.totalCash = value;
      });
    }
  };
}]);
